<template>
  <div class="h5-header-wrapper">
    <header class="apply-guide-header">
      <img
        class="icon"
        :src="theme === 'h5-orange-yellow-guide'?require('../assets/ok-icon-yellow.svg'): require('../assets/ok-icon.svg')"
      />
      <h1 class="title">您已成功购买{{ title }}</h1>
    </header>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Header extends Vue {
  @Prop({ type: String }) title!: string;
  @Prop({ type: String }) theme!: string;
}
</script>

<style lang="scss" scoped>
.h5-header-wrapper {
  width: 100%;
  height: 328px;
  background: #5444c6;
}
.apply-guide-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  background: url('../assets/apply-guide-bg.png') bottom center/100% no-repeat;
  .icon {
    width: 128px;
    height: 128px;
    margin-top: 53px;
  }
  .title {
    margin-top: 20px;
    color: #ffffff;
    font-weight: 400;
    font-size: 34px;
  }
}
</style>
